module.exports = __webpack_public_path__ + "img/simpatra_logo_black.99dfe518.png";